import React, { useEffect, useState } from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableView from "./util/TableView";
import ReceiverDetailDialog from "./dialog/ReceiverDetailDialog";
import Fab from "@mui/material/Fab";
import AddIcon from '@mui/icons-material/Add';
import makeStyles from "@mui/styles/makeStyles";
import StringArrayList from "./util/StringArrayList";
import Moment from "react-moment";

const useStyles = makeStyles(theme => ({
  fab: {
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  rowCursor: {
    cursor: "pointer"
  }
}));

export default function GrinchesView(props) {
  const classes = useStyles();

  const [data, setData] = useState([]);

  useEffect(() => {
    props.setShowSearch(true);
  }, []);


  const tableHeader =
    <TableRow>
      <TableCell>Name</TableCell>
      <TableCell>Comment</TableCell>
      <TableCell>Location</TableCell>
      <TableCell>Active</TableCell>
    </TableRow>;

  const tableRows = (row) =>
    <TableRow
      className={classes.rowCursor}
      key={row.id}
    >
      <TableCell>{row.name}</TableCell>
      <TableCell><div style={{ whiteSpace: 'pre-line' }}>{row.comment}</div></TableCell>
      <TableCell>{row.city}, {row.country}</TableCell>
      <TableCell>{row.isActive ? 'True' : 'False'}</TableCell>
    </TableRow>;


  return (
    <>

      <TableView
        fetchUrl={"grinches"}
        tableHeader={tableHeader}
        tableRows={tableRows}
        searchValue={props.searchValue}
        data={data}
        setData={setData}
        {...props}
      />
    </>
  );
}
